export default "__VITE_ASSET__Bq$awGpv__"